<div class="incoming-call-overlay" *ngIf="showIncomingCall">
  <div class="center-wrapper">
    <div class="consultation-card">
      <!-- HEADER -->
      <div class="header">
        <div class="header-left">
          <div class="call-icon-wrap">
            <i
              class="fas"
              [ngClass]="callType === 'audio' ? 'fa-phone' : 'fa-video'"
            ></i>
          </div>
          <div>
            <div class="incoming-label">Incoming Call</div>
            <div class="call-type-badge">
              <span class="status-dot"></span>
              {{
                callType === "audio"
                  ? "Audio Consultation"
                  : "Video Consultation"
              }}
            </div>
          </div>
        </div>
        <div class="countdown-timer">
          <i class="fas fa-clock"></i>
          {{ autoDisconnectSeconds }}s
        </div>
      </div>

      <!-- PROFILE -->
      <div class="profile">
        <div class="avatar">
          <span class="avatar-char">T</span>
        </div>
        <div class="info">
          <h3>Dr. {{ doctorName }}</h3>

          <!-- <p class="meta-row">
            <span class="meta-tag"
              ><i class="fas fa-user"></i> 34 yrs · Male</span
            >
            <span class="meta-tag patient-id"
              ><i class="fas fa-id-card"></i> #2502</span
            >
          </p>
          <p class="meta-row contact-row">
            <span><i class="fas fa-phone"></i> +263 772 575 454</span>
          </p> -->
        </div>
      </div>

      <!-- REASON -->
      <!-- <div class="reason">
        <div class="reason-header">
          <i class="fas fa-notes-medical"></i>
          <span>Reason for Booking</span>
        </div>
        <p>
          Persistent headache and mild fever for 3 days. Pain gets worse in the
          morning. Took paracetamol with limited relief. Light sensitivity
          noted.
        </p>
      </div> -->

      <!-- GRID -->
      <!-- <div class="info-grid">
        <div class="info-cell">
          <span class="cell-label">Booking Time</span>
          <span class="cell-value">12:55 PM Today</span>
        </div>
        <div class="info-cell">
          <span class="cell-label">Channel</span>
          <span class="cell-value">USSD</span>
        </div>
        <div class="info-cell">
          <span class="cell-label">Allergies</span>
          <span class="cell-value danger-val">
            <i class="fas fa-exclamation-triangle"></i> Penicillin
          </span>
        </div>
        <div class="info-cell">
          <span class="cell-label">Conditions</span>
          <span class="cell-value">Hypertension</span>
        </div>
      </div> -->

      <!-- FILES -->
      <!-- <div class="files">
        <span class="file-chip">
          <i class="fas fa-file-pdf"></i> BloodTest.pdf
        </span>
        <span class="file-chip">
          <i class="fas fa-file-image"></i> XRay_chest.jpg
        </span>
      </div> -->

      <!-- ACTIONS -->
      <div class="actions">
        <button class="btn-decline" (click)="declineCall()">
          <i class="fas fa-phone-slash"></i>
          Decline
        </button>
        <button class="btn-accept" (click)="acceptCall()">
          <i class="fas fa-phone"></i>
          Accept
        </button>
      </div>

      <!-- AUDIO -->
      <audio #ringingAudio loop>
        <source src="assets/audio/ringing_tone.mp3" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</div>
